import { AssetEvent } from './asset.event';
import { EventRegistry } from '../../../../../domain/event/event.registry';
export class AssetUpdatedFromInspectionEvent extends AssetEvent {
    constructor(payload, metadata, fromPersistence) {
        super({
            subject: `asset/${payload.id}`,
            type: AssetUpdatedFromInspectionEvent.type,
            payload,
            metadata,
            fromPersistence,
        });
    }
}
AssetUpdatedFromInspectionEvent.type = 'com.treeplotter.api.asset.updatedFromInspection.v1';
EventRegistry.register(AssetUpdatedFromInspectionEvent.type, AssetUpdatedFromInspectionEvent);
//# sourceMappingURL=asset-updated-from-inspection.event.js.map